import { AxiosInstance } from 'axios'
import { ApiResult, idItem, Pagging } from '../server.api'

// Api interface
export default class SanteNomenclatureApi {
  instance: AxiosInstance

  constructor(instance: AxiosInstance) {
    this.instance = instance
  }

  async get(id: number): Promise<ApiResult<santeNomenclature>> {
    return this.instance.get(`/SanteNomenclature/${id}`)
  }

  async getWithPrestation(id: number): Promise<ApiResult<santeNomenclatureWithPrestation>> {
    return this.instance.get(`/Admin/SanteNomenclature/${id}`)
  }

  async search(search: santeNomenclatureSearch): Promise<ApiResult<Pagging<santeNomenclature>>> {
    return this.instance.post('/SanteNomenclature/search', search)
  }

  async create(newSanteNomenclature: santeNomenclatureCreate): Promise<ApiResult<idItem>> {
    return this.instance.post('/SanteNomenclature', newSanteNomenclature)
  }

  async modify(santeNomenclature: santeNomenclatureUpdate): Promise<ApiResult<idItem>> {
    return this.instance.put('/SanteNomenclature', santeNomenclature)
  }

  async delete(id: number): Promise<ApiResult<idItem>> {
    return this.instance.delete('/SanteNomenclature', { params: { id } })
  }
}

// Types
type santeNomenclatureSearch = {
  page: number
  limit: number
  name?: string
  id?: number
}

type santeNomenclatureCreate = {
  name: string
}

type santeNomenclatureUpdate = {
  id: number
  name: string
}

/*
 * Output
 */
type santeNomenclature = {
  id: number
  name: string
}

type santeNomenclatureWithPrestation = {
  nomenclature: santeNomenclature
  prestations: any
}

export {
  santeNomenclatureWithPrestation,
  santeNomenclatureSearch,
  santeNomenclatureCreate,
  santeNomenclatureUpdate,
  santeNomenclature,
}
